import { BaseModel } from "model/BaseModel";
import Deposito from "./Deposito";
import Produto from "model/administracao/cadastro/produto/Produto";
import EstoqueLote from "./EstoqueLote";


export default class Estoque implements BaseModel {

    id: number;
    codigo: string | null;
    produto: Produto;
    deposito: Deposito;
    quantidade: number;
    quantidadeEmprestada: number;
    quantidadeInutilizavel: number;
    ativo: boolean;
    lotes: Array<EstoqueLote>;
    consumoMedio: number;


    constructor(
        id = 0,
        codigo = null,
        produto = new Produto(),
        deposito = new Deposito(),
        quantidade = 0,
        quantidadeEmprestada = 0,
        quantidadeInutilizavel = 0,
        ativo = true,
        lotes = new Array<EstoqueLote>(),
        consumoMedio = 0
    ) {
        this.id = id;
        this.codigo = codigo;
        this.produto = produto;
        this.deposito = deposito;
        this.quantidade = quantidade;
        this.quantidadeEmprestada = quantidadeEmprestada;
        this.quantidadeInutilizavel = quantidadeInutilizavel;
        this.ativo = ativo;
        this.lotes = lotes;
        this.consumoMedio = consumoMedio;
    }
}
